"use strict";
import { useEthersSigner } from "hooks/useEthersSigner";
import { useBag } from "nft/hooks/useBag";
import { useSendTransaction } from "nft/hooks/useSendTransaction";
import { useTransactionResponse } from "nft/hooks/useTransactionResponse";
import { useCallback } from "react";
export function usePurchaseAssets() {
  const signer = useEthersSigner();
  const sendTransaction = useSendTransaction((state) => state.sendTransaction);
  const setTransactionResponse = useTransactionResponse((state) => state.setTransactionResponse);
  const {
    setLocked: setBagLocked,
    setBagExpanded,
    reset: resetBag
  } = useBag(({ setLocked, setBagExpanded: setBagExpanded2, reset }) => ({
    setLocked,
    setBagExpanded: setBagExpanded2,
    reset
  }));
  return useCallback(
    async (routingData, assetsToBuy, purchasingWithErc20 = false) => {
      if (!signer) {
        return;
      }
      const purchaseResponse = await sendTransaction(signer, assetsToBuy, routingData, purchasingWithErc20);
      if (purchaseResponse) {
        setBagLocked(false);
        setTransactionResponse(purchaseResponse);
        setBagExpanded({ bagExpanded: false });
        resetBag();
      }
    },
    [signer, resetBag, sendTransaction, setBagExpanded, setBagLocked, setTransactionResponse]
  );
}
